import React from "react";
import { X } from "lucide-react";

export default function Drawer({ open, onClose, title, children, footer }) {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50" data-testid="detail-drawer">
      <div className="absolute inset-0 bg-black/40" onClick={onClose} />
      <div className="absolute right-0 top-0 bottom-0 w-full sm:max-w-xl bg-white shadow-2xl flex flex-col">
        <div className="flex items-center justify-between p-5 border-b border-slate-200">
          <h3 className="font-bold text-[#0F2A4A] text-lg">{title}</h3>
          <button onClick={onClose} className="p-2 rounded hover:bg-slate-100" data-testid="drawer-close"><X className="w-5 h-5" /></button>
        </div>
        <div className="flex-1 overflow-y-auto p-5">{children}</div>
        {footer && <div className="p-4 border-t border-slate-200 bg-slate-50">{footer}</div>}
      </div>
    </div>
  );
}
